// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section_wrapper__QliHK","content":"Section_content__XjD1x","responsive":"Section_responsive__MlyTo"};